import { PrivateDocumentDtoType } from '@/shared/lib/forms/documents/private';
import { SJCollection } from '@/shared/lib/sj-orm';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm/models/document/private.document.dto';
import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm/stores/secureJsonCollections.store';
import { CollectionName } from '@/shared/lib/sj-orm/types';

export const usePrivateDocuments = () => {
  // TODO: useSJDatabase cause pdf worker to crash. Research is required
  const colDocuments = useSecureJsonCollectionsStore
    .getState()
    .collections.get(CollectionName.PRIVATE_DOCUMENTS);
  const documents = colDocuments
    ? new SJCollection(CollectionName.PRIVATE_DOCUMENTS, colDocuments, () => {})
    : null;

  const getDocument = (
    documentId?: DtoId,
  ): (PrivateDocumentDto & PrivateDocumentDtoType) | undefined => {
    if (!documentId) return undefined;
    const res = documents?.findById(documentId);

    return res;
  };

  return { getDocument };
};
